import React from "react";
import { DocumentosList } from "../components/documetnosBI/DocumentosList";

export const DocumentosBI = (props) => {
    return (
        <div>
            <div className="card">
                <DocumentosList></DocumentosList>
            </div>
        </div>
    );
};
